import React, { useState } from "react";
import { News } from "../../models/Models";
import View from "../ReactNative/View";
import AppTheme from "../../utils/Theme";
import { Image, Platform, TouchableOpacity } from "react-native";
import User from "../../data/user/User";
import { translate } from "../../utils/Localization/Localization";
import { ROOM_CELL_TYPE } from "../Rooms/SuperRoom";
import { openUrl } from "../../utils/WebLink";
import Text from "../ReactNative/Text";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";

interface ActuSectionProps {
    title?: string;
    forcedWidth?: number;
}

const ActuSection = (props: ActuSectionProps) => {

    const { title, forcedWidth } = props;

    const appTheme: AppTheme = new AppTheme();
    const user: User = User.getInstance();

    const {
        fullScreenWidth,
        fullScreenHeight,
        availableScreenSize,
        contentSize,
        sideMenuSize,
        horizontalSpacing
    } = useSpecificSize();

    const [newsToDisplay, setNewsToDisplay] = useState<News[] | undefined>(undefined);

    let blocksWidth: number = forcedWidth !== undefined ? forcedWidth : contentSize - appTheme.pixelPerfect(20);

    const renderRoomCell = (cellType: ROOM_CELL_TYPE) => {
        let imageSize: number = blocksWidth * 260 / 828;
        if (imageSize > 180) {
            imageSize = 180;
        }
        const cellHeight: number = imageSize + appTheme.pixelPerfect(20);
        const borderRadius: number = cellHeight * 0.2;
        let cellLink: string = "https://lili.cool";
        let cellTitle: string = "";
        let cellSubtitle: string = "";
        let cellImageSource: number | { uri: string } = require("../../assets/img/navigation/nav_icon_salle_profs.png")
        if (cellType === "WEBINAR") {
            cellLink = translate.labels().rooms.actus.webinar.link;
            cellTitle = translate.labels().rooms.actus.webinar.title;
            cellSubtitle = translate.labels().rooms.actus.webinar.body;
            cellImageSource = require("../../assets/img/rooms/ic_webinar.jpg");
        } else if (cellType === "ACTU") {
            if ((newsToDisplay === undefined) || ((newsToDisplay !== undefined) && (newsToDisplay.length === 0))) {
                return <View />;
            }
            cellLink = newsToDisplay[0].url[getLanguage()]
            cellTitle = `À L’ACTU :\n${newsToDisplay[0].title[getLanguage()]}`;
            cellSubtitle = newsToDisplay[0].body[getLanguage()];
            cellImageSource = { uri: newsToDisplay[0].img };
        } else if (cellType === "COMITY") {
            cellLink = translate.labels().rooms.actus.comity.link;
            cellTitle = translate.labels().rooms.actus.comity.title;
            cellSubtitle = translate.labels().rooms.actus.comity.body;
            cellImageSource = require("../../assets/img/rooms/ic_comity.png");
        } else if (cellType === "LECTURE") {
            cellLink = translate.labels().rooms.actus.read_advice.link;
            cellTitle = translate.labels().rooms.actus.read_advice.title;
            cellSubtitle = translate.labels().rooms.actus.read_advice.body;
            cellImageSource = require("../../assets/img/rooms/ic_charivari.jpg");
        } else if (cellType === "WITNESS") {
            cellLink = translate.labels().rooms.actus.witness.link;
            cellTitle = translate.labels().rooms.actus.witness.title;
            cellSubtitle = translate.labels().rooms.actus.witness.body;
            cellImageSource = require("../../assets/img/rooms/ic_parole-super-anim.jpg");
        } else if (cellType === "ANIMATION_PROJECT") {
            cellLink = translate.labels().rooms.actus.animation_project.link;
            cellTitle = translate.labels().rooms.actus.animation_project.title;
            cellSubtitle = translate.labels().rooms.actus.animation_project.body;
            cellImageSource = require("../../assets/img/rooms/ic_seven_projects.jpg");
        } else if (cellType === "MANIFESTO") {
            cellLink = translate.labels().rooms.actus.manifesto.link;
            cellTitle = translate.labels().rooms.actus.manifesto.title;
            cellSubtitle = translate.labels().rooms.actus.manifesto.body;
            cellImageSource = require("../../assets/img/rooms/ic_manifesto.png");
        } else if (cellType === "SLEEPING") {
            cellLink = translate.labels().rooms.actus.sleep_advice.link;
            cellTitle = translate.labels().rooms.actus.sleep_advice.title;
            cellSubtitle = translate.labels().rooms.actus.sleep_advice.body;
            cellImageSource = require("../../assets/img/rooms/ic_sommeil.jpg");
        } else if (cellType === "MODELS") {
            cellLink = translate.labels().rooms.actus.models.link;
            cellTitle = translate.labels().rooms.actus.models.title;
            cellSubtitle = translate.labels().rooms.actus.models.body;
            cellImageSource = require("../../assets/img/rooms/ic_role_models.jpg");
        }
        const titleFontSize: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.pixelPerfectForFont(9) : appTheme.pixelPerfectForFont(7);
        const subtitleFontSize: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.pixelPerfectForFont(8) : appTheme.pixelPerfectForFont(7);
        return <TouchableOpacity key={cellType} onPress={() => openUrl(cellLink)} style={{ width: blocksWidth, marginBottom: appTheme.pixelPerfect(15) }}>
            <View style={{ flexDirection: "row", width: blocksWidth, backgroundColor: appTheme.white, borderRadius: borderRadius, padding: cellHeight * 0.05, alignItems: "center" }}>
                <Image source={cellImageSource} style={{ width: imageSize, height: imageSize, borderRadius: borderRadius - 4 }} />
                <View style={{ flex: 1, paddingStart: appTheme.pixelPerfect(10) }}>
                    <Text numberOfLines={2} style={{ textTransform: "uppercase", fontFamily: appTheme.primaryBoldFont, color: appTheme.darkBlue, fontSize: titleFontSize, paddingEnd: appTheme.pixelPerfect(10) }}>
                        {cellTitle}
                    </Text>
                    <Text numberOfLines={appTheme.getFlexDirectionForSplitScreen() === "row" ? 2 : 3} style={{ paddingVertical: 2, fontFamily: appTheme.primaryFont, color: appTheme.darkBlue, fontSize: subtitleFontSize }}>
                        {cellSubtitle}
                    </Text>
                </View>
            </View>
        </TouchableOpacity>
    }

    const renderRoomCells = () => {
        let roomCells: React.JSX.Element[] = [];
        if (user.profile === "family") {
            roomCells = [
                renderRoomCell("SLEEPING"),
                renderRoomCell("MODELS"),
                renderRoomCell("COMITY"),
                renderRoomCell("MANIFESTO")
            ]
        } else if (user.profile === "teacher") {
            roomCells = [
                renderRoomCell("WEBINAR"),
                renderRoomCell("COMITY"),
                renderRoomCell("LECTURE"),
                renderRoomCell("ACTU")
            ]
        } else if (user.profile === "animator") {
            roomCells = [
                renderRoomCell("WEBINAR"),
                renderRoomCell("ANIMATION_PROJECT"),
                renderRoomCell("WITNESS"),
                renderRoomCell("COMITY")
            ]
        }
        if (appTheme.getFlexDirectionForSplitScreen() === "row") {
            let matrixRoomCells: React.JSX.Element[] = [];
            let matrixRoomCellLine: React.JSX.Element[] = [];
            for (const aCell of roomCells) {
                matrixRoomCellLine.push(aCell);
                if (matrixRoomCellLine.length === 2) {
                    matrixRoomCells.push(<View style={{ width:2*blocksWidth + 10, flexDirection: "row", gap:10}}>
                        {matrixRoomCellLine}
                    </View>);
                    matrixRoomCellLine = [];
                }
            }
            if (matrixRoomCellLine.length > 0) {
                matrixRoomCells.push(<View style={{ width:2*blocksWidth + 10, flexDirection: "row", gap:10 }}>
                    {matrixRoomCellLine}
                </View>);
            }
            return matrixRoomCells;
        }
        return roomCells;
    }

    const renderTitle = () => {
        if (title === undefined) {
            return null;
        }
        return <Text style={{ marginBottom: appTheme.pixelPerfect(20), fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(12), textAlign: "center", textTransform: "uppercase", color: user.profile === "family" ? "#FFFFFF" : appTheme.darkBlue }}>{title}</Text>;
    }

    return <View style={{ width: contentSize, alignItems: "center" }}>
        {renderTitle()}
        {renderRoomCells()}
    </View>
}

export default ActuSection;